import React, { useState, useEffect, useRef } from "react";
import { CheckIcon, CloseIcon } from "../../../constants/Icons";

const MAX_LENGTH = 300;

const RemarkModal = ({ open, onClose, onSave, initialValue }) => {
  const [value, setValue] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (open) {
      setValue(initialValue || "");
      textareaRef.current.focus();
    }
  }, [open, initialValue]);

  // Auto height adjust
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [value]);

  if (!open) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 999 }}>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable  modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Add Remark</h6>

              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body bg-light">
              <textarea
                ref={textareaRef}
                className="form-control"
                rows={4}
                maxLength={MAX_LENGTH}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Type your remark..."
                style={{
                  resize: "vertical",
                  overflowY: "auto",
                  minHeight: "200px",
                }}
              />

              <div className="text-end mt-1">
                <small className="text-muted">
                  {value.length}/{MAX_LENGTH}
                </small>
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                onClick={onClose}
                type="button"
                className="btn btn-outline-secondary"
              >
                <CloseIcon iClass={"fs-15"} /> Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  onSave(value.trim());
                  onClose();
                }}
              >
                <CheckIcon /> Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemarkModal;
